function Policy() {
    return (
        <div className="w-full h-[100vh] flex flex-row items-center justify-center   uppercase font-bold text-2xl ">
            POLICY
        </div>
    );
}

export default Policy;
